function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  /* Customize the label (the container) */\n  display: block;\n  position: relative;\n  cursor: pointer;\n  height: ",
        ";\n  width: ",
        ";\n  user-select: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  /* Hide the browser's default checkbox */\n  position: absolute;\n  opacity: 0;\n  height: ",
        ";\n  width: ",
        ";\n  z-index: 1;\n  cursor: pointer;\n\n  /* When the checkbox is checked, add a background color */\n  &:checked ~ span {\n    background-color: ",
        ";\n    border-color: ",
        ";\n  }\n\n  /* Show the indicator (dot/circle) when checked */\n  &:checked ~ span:after {\n    display: block;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: ",
        ";\n  width: ",
        ";\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n\n  /* Create the indicator (checkmark) */\n  &:after {\n    content: '';\n    position: absolute;\n    display: none;\n    top: 45%;\n    left: 55%;\n    transform: translate(-50%, -50%) rotate(45deg);\n    width: ",
        ";\n    height: ",
        ";\n    border: solid ",
        ";\n    box-shadow: 0 1px 0 0 #2b8943;\n    border-width: 0 2px 2px 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
/**
 * @param {String} name
 * @param {String} value "yes", "no"
 * @param {Integer} height [n=20]
 * @param {Integer} width [n=20]
 * @param {Integer} checkHeight [n=9]
 * @param {Integer} checkWidth [n=5]
 * @param {String} checkColor [n='#ffffff']
 * @param {String} borderColor [n='#3f6b9e']
 * @param {String} backgroundColor [n='#eff5fc']
 * @param {String} checkedBackgroundColor [n='#eff5fc']
 * @param {String} id [Supports labels using the "for" property. i.e. - you can click a label]
 * @example
 *   import { Checkbox } from 'shared/components/';
 *
 *   <Checkbox
 *     name="dispensaryTypeMedical"
 *     value="medical"
 *     height={18}
 *     width={18}
 *     checkColor="#ffffff"
 *     borderColor="#3f6b9e"
 *     backgroundColor="#eff5fc"
 *     checkedBackgroundColor="#eff5fc"
 *   />
 *
 * @example - Using 'react-final-form'
 *
 *   <Field
 *     name="dispensaryTypeMedical"
 *     value="medical"
 *     type="checkbox"
 *     height={18}
 *     width={18}
 *     render={({ input, meta, ...rest }) => <Checkbox {...input} {...rest} />}
 *   /> Medical
 */ var Container = styled.div(_templateObject(), function(props) {
    return "".concat(props.height || 20, "px");
}, function(props) {
    return "".concat(props.width || 20, "px");
});
var StyledCheckbox = styled.input(_templateObject1(), function(props) {
    return "".concat(props.height || 20, "px");
}, function(props) {
    return "".concat(props.width || 20, "px");
}, function(props) {
    return props.checkedBackgroundColor || '#3bba5b';
}, function(props) {
    return props.checkedBackgroundColor || '#3bba5b';
});
var CustomCheckbox = styled.span(_templateObject2(), function(props) {
    return "".concat(props.height || 20, "px");
}, function(props) {
    return "".concat(props.width || 20, "px");
}, function(props) {
    return props.backgroundColor || '#eff5fc';
}, function(props) {
    return props.borderColor || '#3f6b9e';
}, function(props) {
    return "".concat(props.checkWidth || 5, "px");
}, function(props) {
    return "".concat(props.checkHeight || 9, "px");
}, function(props) {
    return props.checkColor || '#ffffff';
});
var Checkbox = function(_param) {
    var id = _param.id, props = _object_without_properties(_param, [
        "id"
    ]);
    return /*#__PURE__*/ _jsxs(Container, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx(StyledCheckbox, _object_spread_props(_object_spread({}, props), {
                id: id,
                type: "checkbox"
            })),
            /*#__PURE__*/ _jsx(CustomCheckbox, _object_spread({}, props))
        ]
    }));
};
export default Checkbox;
